module.exports = __webpack_public_path__ + "img/video_2.bf86bd13.png";